/* global AbortController, HTMLElement, document, window */

export class ThreeDResponsiveBanner extends HTMLElement {
  connectedCallback() {
    this.disconnectedCallback()

    this.abortController = new AbortController()
    this.video = this.querySelector('[data-3d-banner-video]')
    if (!this.video) return

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.updateVideo = this.updateVideo.bind(this)
    this.handleVisibility = this.handleVisibility.bind(this)

    window.addEventListener('resize', this.updateVideo, {
      signal: this.abortController.signal,
    })
    document.addEventListener('visibilitychange', this.handleVisibility, {
      signal: this.abortController.signal,
    })
    this.reducedMotion.addEventListener?.('change', this.updateVideo, {
      signal: this.abortController.signal,
    })

    this.updateVideo()
  }

  disconnectedCallback() {
    this.abortController?.abort()
    this.abortController = null
    this.video?.pause?.()
    this.video = null
  }

  updateVideo() {
    if (!this.video) return

    const width = window.innerWidth
    const mobile = !(width >= 1440 || width > window.innerHeight)
    const nextSource = mobile ? this.video.dataset.videoMb : this.video.dataset.videoPc

    if (nextSource && this.video.getAttribute('src') !== nextSource) {
      this.video.setAttribute('src', nextSource)
      this.video.load?.()
    }

    if (this.reducedMotion?.matches || document.hidden) {
      this.video.pause?.()
      return
    }

    this.video.play?.().catch?.(() => {})
  }

  handleVisibility() {
    this.updateVideo()
  }
}

if (globalThis.customElements && !globalThis.customElements.get('lp-three-d-banner')) {
  globalThis.customElements.define('lp-three-d-banner', ThreeDResponsiveBanner)
}
